import { render, staticRenderFns } from "./kindChooseViewzb.vue?vue&type=template&id=60859382&scoped=true"
import script from "./kindChooseViewzb.vue?vue&type=script&lang=js"
export * from "./kindChooseViewzb.vue?vue&type=script&lang=js"
import style0 from "./kindChooseViewzb.vue?vue&type=style&index=0&id=60859382&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60859382",
  null
  
)

export default component.exports